// Widget page-observation adapter api module — generator-facing surface for the
// dashboard-v2 Widget Studio page-observation list.
//
// CHG-2471 / ITER-905213 — Widget Studio S5 (observations, read-only list-only).
//
// Append-only telemetry: no detail, no write surface (the hint declares
// pages.list_v2 only). Maps the ListPage queryFn contract onto the landed
// widgets-admin client.

import { widgetsAdminApi } from "./widgets-admin";
import type { WidgetPageObservation } from "./types";

export interface ListWidgetPageObservationsParams {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
  filters?: Record<string, string | number | boolean | undefined>;
}

// GET /admin/widgets/page-observations mapped to the ListPage contract. Filters
// (domain / widget_instance_id / page_type) are wired through; search/sort are
// forward-promised (no BE param yet), same posture as the S3/S4 adapters.
export async function listWidgetPageObservations(
  params: ListWidgetPageObservationsParams = {},
): Promise<{ items: WidgetPageObservation[]; total: number }> {
  const pageSize = params.pageSize ?? 50;
  const page = params.page ?? 0;
  const f = params.filters ?? {};
  const env = await widgetsAdminApi.listPageObservations({
    domain: f.domain as string | undefined,
    widget_instance_id: f.widget_instance_id as string | undefined,
    page_type: f.page_type as string | undefined,
    limit: pageSize,
    offset: page * pageSize,
  });
  return { items: env.items, total: env.total };
}

export const widgetPageObservationsApi = {
  listWidgetPageObservations,
};
